// Font Awesome (0)
import Vue from "vue";
import { library } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)

// List all font awesome image
import { fas } from '@fortawesome/free-solid-svg-icons'
library.add(fas);
